import '@fancyapps/fancybox/dist/jquery.fancybox.min';
import 'bootstrap/js/src/collapse';
import 'bootstrap/js/src/popover';
import 'bootstrap/js/src/tooltip';
import 'bootstrap/js/src/modal';
import Modernizr from 'modernizr';
import LazyLoad from "vanilla-lazyload";
import Isotope from 'isotope-layout/dist/isotope.pkgd.min';

export default class Utils {

	static state = 1;

	constructor()
	{
		Utils.click();
		Utils.bootstrap();
		Utils.fancybox();
		Utils.searchbox();
		Utils.smooth_scroll();
		Utils.lazy();
		Utils.block_cover();
		Utils.obfuscation();
		Utils.sticky_navbar();
		Utils.show_more();
		Utils.isotope();
		Utils.infoLive();
		Utils.facebookEvent();
		Utils.langs_switcher();
		Utils.replace_broken_image();
	}

	static replace_broken_image()
	{
		// For local environment only
		if ( window.location.hostname.match( /.iris.io/ ) ) {
			let url = 'https://www.falaise-suissenormande.com';
			$( 'img' ).on( 'error', function ( e ) {
				let src     = $( this ).attr( 'src' );
				let new_src = src.replace( Theme.server_url, url );
				$( this ).attr( 'src', new_src );
			} );
		}
	}

	static click()
	{
		const trigger = '[data-trigger="wpiris-click"]';

		if ( !Modernizr.touchevents ) {
			let ctrl = 0;
			$( window ).on( 'keydown', function ( e ) {
				if ( e.which == 17 || e.which == 91 ) {
					ctrl = true
				}
			})
			$( window ).on( 'keyup', function () {
				ctrl = false
			})

			$( document ).on( 'mouseup', trigger, function ( e ) {

				if( e.target.tagName.toLowerCase() !== 'a' ) {
					if (e.which == 1 || e.which == 2) {
						let blank = false
						let url = $(this).find("a").attr("href")
						if (e.which == 2) {
							blank = true
						} // Clic molette
						if ($(this).find("a").attr("target") == "_blank") {
							blank = true
						}
						if (blank || ctrl) {
							window.open(url, '_blank')
						} else {
							window.location = url
						}
						return false
					}
				}
				return false

			} )
		} else {
			$( document ).on( 'click', trigger, function ( e ) {

				let blank = false
				let url   = $( this ).find( "a" ).attr( "href" )
				if ( $( this ).find( "a" ).attr( "target" ) == "_blank" ) {
					blank = true
				}
				if ( blank ) {
					window.open( url, '_blank' )
				} else {
					window.location = url
				}
				return false

			} )
		}
	}

	static bootstrap()
	{
		if ( !Modernizr.touchevents ) {
			$( '[data-toggle="tooltip"]' ).tooltip( { trigger: "hover" } )
		}

		$( '[data-toggle="popover"]' ).popover();
	}

	static fancybox()
	{

		$( '.hentry a:has(>img):not([target="_blank"]):not("[nofancybox]")' ).each( function( ) {

			const href = $( this ).attr( 'href' );

			if ( href.match( /(.jpg|.jpeg|.png|.gif|.svg|.webp)$/ ) ) {
				$( this ).attr( 'data-fancybox', 'fancybox' );
			} else {
				if ( href.indexOf( Theme.server_url ) === -1 ) {
					$( this ).attr( 'target', '_blank' );
				}
			}
		} );


		let counter = 0;
		$( '.hentry .wp-block-gallery' ).each( function () {
			counter++;
			$( this ).find( 'a:has(>img):not([target="_blank"]):not("[nofancybox]")' ).attr( 'data-fancybox', 'wp-block-gallery-' + counter );
		} );

		counter = 0;
		$( '.hentry .wp-block-image' ).each( function () {
			counter++;
			$( this ).find( 'a:has(>img):not([target="_blank"]):not("[nofancybox]")' ).attr( 'data-fancybox', 'wp-block-image-' + counter );
		} );

		$( '[data-fancybox]' ).fancybox( {
			buttons: [
				"zoom",
				"slideShow",
				"close"
			],
			backFocus: false,
			lang: "fr",
			i18n: {
				fr: {
					CLOSE: Theme.translate.fancybox_close,
					NEXT: Theme.translate.fancybox_next,
					PREV: Theme.translate.fancybox_prev,
					ERROR: Theme.translate.fancybox_error,
					PLAY_START: Theme.translate.fancybox_start,
					PLAY_STOP: Theme.translate.fancybox_stop,
					FULL_SCREEN: Theme.translate.fancybox_full_screen,
					THUMBS: Theme.translate.fancybox_thumbs,
					DOWNLOAD: Theme.translate.fancybox_download,
					SHARE: Theme.translate.fancybox_share,
					ZOOM: Theme.translate.fancybox_zoom
				},
			},
			caption: function ( instance, item ) {
				let caption = $( this ).closest( 'figure' ).find( 'figcaption' ).html()

				if ( !caption ) {
					caption = $( this ).find( 'img' ).attr( 'title' )
				}

				if ( !caption ) {
					caption = $( this ).find( 'img' ).attr( 'alt' )
				}

				return caption
			}
		} )
	}

	static searchbox()
	{
		const trigger  = '[data-trigger="wpiris-search-layout"]',
			close    = '[data-trigger="wpiris-search-layout-close"]',
			$element = $('[data-id="wpiris-search-layout"]');

		$( document ).on( 'click', trigger, function ( e ) {
			e.preventDefault();
			$element.fadeIn().find('input').focus();
		} )

		$( document ).on( 'click', close, function ( e ) {
			e.preventDefault();
			$element.fadeOut();
		} )
	}

	static smooth_scroll()
	{
		const trigger = '[data-trigger="wpiris-scroll"]';

		$( document ).on( 'click', trigger, function ( e ) {
			e.preventDefault();

			const target = $(this).attr("href") != '' ? $(this).attr("href") : $(this).attr("data-href"),
				duration = 1000,
				scroll_top = $( target ).offset().top - ( undefined !== e.currentTarget.dataset.shift ? e.currentTarget.dataset.shift : 0 );

			$( 'html, body' ).animate( {
				scrollTop: scroll_top
			}, {
				duration: duration,
				step: ( now, fx ) => {
					let real_pos = scroll_top;
					if ( fx.end !== real_pos ) {
						fx.end = real_pos;
					}
				}
			});
		})
	}

	static lazy()
	{
		const lazyLoadInstance = new LazyLoad({
			elements_selector: '[data-src], [data-bg], [data-bg-hidpi]'
		});
		window.onbeforeprint = function () {
			lazyLoadInstance.loadAll();
		};
	}

	static block_cover() {
		$( '.wp-block-cover:has(.wp-block-cover__inner-container a)' ).attr( 'data-trigger', 'wpiris-click' )
	}

	static obfuscation()
	{
		let element = "[data-obf]";
		if ( $( element ).length > 0 ) {
			if ( !Modernizr.touchevents ) {
				let ctrl = 0;
				$( window ).on( 'keydown', function ( e ) {
					if ( e.which == 17 || e.which == 91 ) {
						ctrl = true;
					}
				} );
				$( window ).on( 'keyup', function () {
					ctrl = false;
				} );

				$( document ).on( 'mouseup', element, function ( e ) {
					let url    = atob( $( this ).attr( 'data-obf' ) );
					let target = $( this ).attr( 'data-obf-target' );
					if ( e.which == 1 || e.which == 2 ) {
						let blank = false;
						if ( e.which == 2 ) {
							blank = true;
						} // Clic molette
						if ( target == "_blank" ) {
							blank = true;
						}
						if ( blank || ctrl ) {
							window.open( url, '_blank' );
						} else {
							window.location = url;
						}
						return false;
					}

					return false;

				} );
			} else {
				$( document ).on( 'click', element, function ( e ) {
					let blank  = false;
					let url    = atob( $( this ).attr( 'data-obf' ) );
					let target = $( this ).attr( 'data-obf-target' );
					if ( target == "_blank" ) {
						blank = true;
					}
					if ( blank ) {
						window.open( url, '_blank' );
					} else {
						window.location = url;
					}
					return false;
				} );
			}
		}
	}

	static sticky_navbar() {
        let that = this;
        let changeLogo = Theme.blog_id == '2';
        let logoHasChange = false;

        if (changeLogo && $('header.header--large').length > 0 && $(window).scrollTop() === 0) {
            that.changeLogo('banner');
        }

		let last_scroll = 0,
			direction = null,
			trigger_height = $('.navbar').outerHeight(),
			$element = $('.navbar');

		// On scroll
		$(window).scroll(function () {

			let scroll = $(window).scrollTop();

			// Determine wich direction
			if (scroll > last_scroll) {
				direction = 'bottom';
				last_scroll = scroll;
			} else {
				direction = 'top';
				last_scroll = scroll;
			}

			// Set sticky when scroll up
			if ((direction == "bottom") && (scroll > 30)) {
				$element.removeClass('is-sticky');
				$element.addClass('is-hidden');
			} else {
				$element.addClass('is-sticky');
				$element.removeClass('is-hidden');
			}

			// Remove class if scroll top
			if (scroll == '0') {
				$element.removeClass('is-sticky');
			}

            if(changeLogo){
                if($('.home').length > 0 || $('.header--large').length > 0){
                    if (scroll == '0') {
                        that.changeLogo('banner');
                        logoHasChange = false;
                    } else if(!logoHasChange){
                        setTimeout(() => {
                            that.changeLogo('classic');
                            logoHasChange = true;
                        }, 250)
                    }
                }
            }
		});
	}

	static show_more()
	{
		let trigger = "[data-trigger='wpiris-show-more']";
		$( document ).on( 'click', trigger, function ( e ) {
			e.preventDefault();
			let attr = $( this ).attr( 'href' );
			$( attr ).toggleClass( 'show' );
			$( this ).hide();
		} );
	}

	static isotope() {

		const grid = document.querySelector('[data-isotope-grid]'),
			$grid = $('[data-isotope-grid]'),
			$filters = $('[data-isotope-filters]'),
			current_class = 'current';

		if ( $grid.length > 0 ) {

			// Init isotop
			var isotope = new Isotope( grid, {
				itemSelector: '[data-isotope-item]',
				masonry: {
					columnWidth: '[data-isotope-grid-sizer]',
					gutter: '[data-isotope-gutter-sizer]',
				},
			} );

			// Filters
			if ($filters.length > 0) {

				// Filter items on button click
				$filters.on('click', 'a', function (e) {
					e.preventDefault();
					let filter_value = $(this).attr('data-isotope-filter');
					isotope.arrange({filter: filter_value});
				});

				// Change class on click
				$filters.each(function (i, button_group) {
					let $button_group = $(button_group);
					$button_group.on('click', 'a', function () {
						$button_group.find('.' + current_class).removeClass(current_class);
						$(this).addClass(current_class);
					});
				});
			}
		}
	}

	static infoLive(){
		const container = '[data-id="infoliveContainer"]';
		const target = '[data-id="infolive"]';

		if(target.length) {
			const targetWidth = $(target).width();
			const containerWidth = $(container).width();

			if(targetWidth > containerWidth) {
				Utils.autoScroll(container, containerWidth, targetWidth);
			}
		}
	}

	static autoScroll(container, containerWidth, targetWidth) {
		const scrollInterval = 15;
		const delay = 2500;
		let leftDistance = $(container).scrollLeft();
		let interval = null;
		let timeout = null;
		let isPaused = false;

		startScroll();

		$(container).mouseenter( () => {
			clearInterval(interval);
		});

		$(container).mouseleave( () => {
			callInterval();
		});

		function startScroll() {
			timeout = setTimeout(function(){
				callInterval()
			}, delay)
		}

		function resetScroll() {
			clearInterval(interval);
			leftDistance = 0;
			$(container).scrollLeft(0);
			startScroll();
		}

		function callInterval(){

			interval = setInterval(function() {
				if(leftDistance + containerWidth < targetWidth){
					$(container).scrollLeft(leftDistance);
					leftDistance++;
				}else{
					resetScroll();
				}
			}, scrollInterval )
		}
	}

	static facebookEvent() {

		let wpetBlock = $('.wp-block-wpet-hide');
		let fbDialog = $('.fb_dialog');

		if(Modernizr.touchevents){
			callFbPlugin();
		}else{
			$(document).scroll(function () {
				if ($('.fb_dialog--visible').length === 0) {
					if ($(document).scrollTop() > 900) {
						callFbPlugin();
					}
				}
			});
		}

		if (wpetBlock.length > 0 && fbDialog.length > 0) {
			fbDialog.addClass('fb_dialog--upper')
		}

		function callFbPlugin(xfbmlStatus= true){
			var chatbox = document.getElementById('fb-customer-chat');
			chatbox.setAttribute("page_id", "268602496669631");
			chatbox.setAttribute("attribution", "biz_inbox");
			window.fbAsyncInit = function() {
				FB.init({
					xfbml            : xfbmlStatus,
					version          : 'v12.0'
				});

				FB.Event.subscribe('customerchat.load', function(){
					let trigger = '[data-trigger="wpiris-show-messenger"]';
					$(trigger).addClass('is-loaded');
					$(document).on('click', trigger , function (e) {
						FB.CustomerChat.showDialog();
					});
				});
			};

			(function(d, s, id) {
				var js, fjs = d.getElementsByTagName(s)[0];
				if (d.getElementById(id)) return;
				js = d.createElement(s); js.id = id;
				js.src = 'https://connect.facebook.net/fr_FR/sdk/xfbml.customerchat.js';
				fjs.parentNode.insertBefore(js, fjs);
			}(document, 'script', 'facebook-jssdk'));
		}
	}

	static initialize_instagram() {

		let $wrapper = $('[data-instagram-wall]');

		if ($wrapper.length > 0) {
			self = this;
			$.ajax({
				url: Theme.ajax_url,
				data: {
					'action': 'social_wall',
				},
				type: 'POST',
				success: function (socialData) {
					$wrapper.append(socialData);
				}
			});
		}
	}

	static langs_switcher() {
		const select_lang = $(".langCurrent");

		//Init select lang
		$( window ).on( 'load', function () {
			setTimeout(function(){
				let current_language = $( 'html' ).attr( 'lang' ).replace( /-.*/gi, '' );
				$(select_lang).text(current_language.toUpperCase()).text();

				//Remove current language on list (init)
				$( '.langList > a' ).each( function () {
					if ($(this).text() === current_language.toUpperCase()) {
						$(this).hide();
					}
				});
			}, 300)
		} );

		//Change Navbar Language on click
		$(".langList > a").on("click", function () {
			$(".langList > a").show();
			$(this).hide();
			$(select_lang).text($(this).text());
		})
	}

    static changeLogo(context) {
        const logo = $('[data-id="wpiris-logo"]')
        let logoBanner
        let logoClassic

        logoBanner = Theme.stylesheet_url + '/assets/dist/images/logo-banner.svg';
        logoClassic = Theme.stylesheet_url + '/assets/dist/images/logo.svg';

        if (context === 'banner') {
            logo.attr('src', logoBanner)
        } else if (context === 'classic') {
            logo.attr('src', logoClassic)
        }
    }

}
